export default __webpack_public_path__ + "static/media/LECLERC_02.2f27a701.gif";